// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MorePosts__posts":"po_a bia_rc bia_qx bia_xr"};